export const FETCH_ALL_JOBS = "FETCH_ALL_JOBS";
export const FETCH_JOB = "FETCH_JOB";
export const CREATE_JOB = "CREATE_JOB";
export const UPDATE_JOB = "UPDATE_JOB";
export const DELETE_JOB = "DELETE_JOB";
